<itl-wizard-page
  [pageTitleTransPath]="orderIsNew ? 'order.createOrder' : 'order.editOrder'"
  [sectionTitleTransPath]="currentSection?.nameTransPath"
  [allPageCount]="wizardSteps.length"
  [currentPageId]="pageID + 1"
  [pageIsValid]="isValid"
  (cancelClicked)="cancel()"
  (doneClicked)="done()"
  (loadNextClicked)="nextSection()"
  (loadPreviousClicked)="previousSection()"
  (sectionChangeClicked)="changePage()"
>
  <itl-loading-indicator *ngIf="loading"></itl-loading-indicator>
  <ng-container *ngIf="form && !loading">
    <itl-info-box *ngFor="let error of form.errors | keys" [type]="warningType">
      {{ 'validation.errors.' + error | translate }}</itl-info-box
    >
    <ng-container *ngIf="reminderForm">
      <itl-single-order-masterdata
        *ngIf="pageID === 0"
        [order]="singleOrderViewModel"
        [reminderForm]="reminderForm"
        [form]="form"
        [hasReminder]="hasReminder"
        [canSetDeliveryDateUnknown]="canSetDeliveryDateUnknown"
        [isNew]="orderIsNew"
        (reminderToggled)="reminderToggled($event)"
        [isMonthlyOrderActivated]="this.integratedCare?.isMonthlyOrderActivated || false"
      ></itl-single-order-masterdata>
    </ng-container>
    <itl-single-order-articledata
      *ngIf="pageID === 1"
      [order]="singleOrderViewModel"
      [form]="form"
      [isNew]="orderIsNew"
      [(templateRef)]="templateRef"
    >
    </itl-single-order-articledata>
  </ng-container>

  <itl-single-order-summary [order]="singleOrderViewModel" *ngIf="pageID === 2"></itl-single-order-summary>
  <itl-wizard-page-footer>
    <ng-container *ngIf="templateRef">
      <div *ngTemplateOutlet="templateRef"></div>
    </ng-container>
  </itl-wizard-page-footer>
</itl-wizard-page>
